module.exports = __webpack_public_path__ + "media/images/portal/main-img-ecee07116969da15a63ddd2ae461c3b3.png";